import { fg } from '@atlaskit/platform-feature-flags';

// This function is used to get the feature flags that should be passed down to Forge Custom UI apps
export const getPlatformFeatureFlags = (): string[] => {
	const platformFeatureFlags: string[] = [];
	// Add feature flags that are required to be passed down to the iframe
	// EXAMPLE:
	// if (fg(<flag-name>)) {
	// 	platformFeatureFlags.push(<flag-name>);
	// }

	if (fg('forge-ui-app-perf-tracking-enabled')) {
		platformFeatureFlags.push('forge-ui-iframe-analytics');
	}
	if (fg('forge-ui-bridge-core-reset')) {
		platformFeatureFlags.push('forge-ui-bridge-core-reset');
	}
	if (fg('platform_ufo_3p_segment_timings')) {
		platformFeatureFlags.push('forge-ui-iframe-ufo-perf-observers');
	}

	return platformFeatureFlags;
};
